export function tsToInput(ts: number): string {
	const date = new Date(ts * 1000);
	const year = date.getFullYear();
	const month = (date.getMonth() + 1).toString().padStart(2, "0");
	const day = date.getDate().toString().padStart(2, "0");
	return `${year}-${month}-${day}`;
}

export function formatIDArt(idComponente: string, idFase: number) {
	// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- Support legacy cases
	if (idFase == null || idFase == 0) return "#" + idComponente;
	else return "#" + idComponente + "-F" + String(idFase);
}